module.exports = __webpack_public_path__ + "static/media/matchmaster.792b5eaa.svg";